import { forwardRef } from 'react';
import { Button, Typography, Stack, IconButton, Box } from '@mui/material';
import Close from '@mui/icons-material/Close';
import NerdWalletLogo from '../nerdwallet-logo';
import * as copy from './constants';

interface ExitModalContentProps {
  handleClose?: () => void;
  onCancel?: () => void;
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 630,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  outline: 0,
  display: 'flex',
  flexDirection: 'column',
  paddingX: 5,
  paddingY: 5,
};

const ExitModalContent: React.FC<ExitModalContentProps> = forwardRef<
  HTMLDivElement,
  ExitModalContentProps
>(({ handleClose, onCancel }, ref) => {
  return (
    <Stack
      ref={ref}
      sx={(theme) => ({
        ...modalStyle,
        [theme.breakpoints.down('md')]: {
          paddingX: 3,
          paddingY: 5,
          li: { marginY: 2 },
        },
      })}
      spacing={3}
      tabIndex={-1}
    >
      <Box sx={{ display: 'flex', width: '100%', marginBottom: 1 }}>
        <Box sx={{ flex: '1' }}>
          <NerdWalletLogo />
        </Box>
        <Box sx={{ flex: '1', textAlign: 'right' }}>
          <IconButton
            aria-label="Close"
            onClick={handleClose}
            sx={{
              color: 'neutral.main',
              cursor: 'pointer',
            }}
          >
            <Close />
          </IconButton>
        </Box>
      </Box>
      <Typography variant="titleSmall" component="h2">
        {copy.title}
      </Typography>
      <Typography
        variant="textLarge"
        component="div"
        sx={(theme) => ({
          [theme.breakpoints.down('md')]: { fontSize: '1rem' },
        })}
      >
        {copy.subHeader}
        <Box marginY={2} paddingLeft={4} component="ul">
          <li>{copy.bulletOne}</li>
          <li>{copy.bulletTwo}</li>
          <li>{copy.bulletThree}</li>
        </Box>
      </Typography>
      <Button onClick={handleClose} fullWidth>
        {copy.primaryCTA}
      </Button>
      <Button onClick={onCancel} variant="outlined" fullWidth>
        {copy.secondaryCTA}
      </Button>
    </Stack>
  );
});

ExitModalContent.displayName = 'ExitModalContent';

export default ExitModalContent;
